import React, { useMemo, useState } from "react";

import MentionAutocomplete from "./MentionAutocomplete";

const TAGS = ["SCORM", "QUIZ", "VIDEO", "PDF", "EVALUATION", "EVENEMENT", "GENERAL"];
const CONTENT_TAGS = {
    SCORM: "SCORM",
    VIDEO: "VIDEO",
    PDF: "PDF",
    QUIZ: "QUIZ",
    EVALUATION: "EVALUATION",
    EVENEMENT: "EVENEMENT",
};

export default function ContentQuestionForm({ moduleId, context, onCancel, onSubmit, submitting }) {
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const defaultTags = useMemo(() => {
        const contentTag = CONTENT_TAGS[String(context?.contentTypeContext || "").toUpperCase()];
        return contentTag ? [contentTag] : ["GENERAL"];
    }, [context?.contentTypeContext]);
    const [tags, setTags] = useState(defaultTags);
    const [files, setFiles] = useState([]);

    const toggleTag = (tag) => {
        setTags((current) => current.includes(tag)
            ? current.filter((value) => value !== tag)
            : [...current, tag]);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        onSubmit?.({
            title,
            message,
            contentTypeContext: context?.contentTypeContext,
            videoTimestampSeconds: context?.videoTimestampSeconds,
            pdfPage: context?.pdfPage,
            scormNodeId: context?.scormNodeId,
            scormNodeTitle: context?.scormNodeTitle,
            scrollPosition: context?.scrollPosition,
            tags,
            files,
        });
    };

    return (
        <form className="cq-form" onSubmit={handleSubmit}>
            <input
                className="cq-input"
                value={title}
                onChange={(event) => setTitle(event.target.value)}
                placeholder="Titre de la question"
                maxLength={255}
                required
            />
            <MentionAutocomplete
                moduleId={moduleId}
                value={message}
                onChange={setMessage}
                placeholder="Votre question"
                required
            />
            <div className="cq-tag-picker">
                {TAGS.map((tag) => (
                    <label key={tag} className={`cq-tag-choice ${tags.includes(tag) ? "is-active" : ""}`}>
                        <input
                            type="checkbox"
                            checked={tags.includes(tag)}
                            onChange={() => toggleTag(tag)}
                        />
                        {tag}
                    </label>
                ))}
            </div>
            <label className="cq-file-field">
                <span>Pieces jointes</span>
                <input
                    type="file"
                    multiple
                    accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.txt,.xlsx"
                    onChange={(event) => setFiles(Array.from(event.target.files || []))}
                />
            </label>
            {files.length > 0 ? (
                <div className="cq-file-preview">
                    {files.map((file) => (
                        <span key={`${file.name}-${file.size}`}>{file.name}</span>
                    ))}
                </div>
            ) : null}
            <div className="cq-form-actions">
                <button type="submit" className="cq-btn cq-btn--primary" disabled={submitting}>
                    Publier
                </button>
                <button type="button" className="cq-btn" onClick={onCancel} disabled={submitting}>
                    Annuler
                </button>
            </div>
        </form>
    );
}
